import BaseRequests from "@/requests/BaseRequests";

/**
 * Auth requests
 *
 * @param {ApiHelper} api
 */
export default class AuthRequests extends BaseRequests {
    baseUrl = '/auth';

    constructor(api) {
        super(api);
    }


    async me(errorHandler = () => {}) {
        let url = this.baseUrl + '/me';

        return this.api.getRequest(url)
            .then(response => {
                console.log("me:", response);

                return this.processResponse(response, errorHandler);
            })
            .catch(error => typeof errorHandler === 'function' ? errorHandler(error) : null);
    }


    async updateMe(data, errorHandler = () => {}) {
        let url = this.baseUrl + '/me';

        return this.api.putRequest(url, data)
            .then(response => this.processResponse(response, errorHandler))
            .catch(error => { if (typeof errorHandler === 'function') errorHandler(error); return false; });
    }


    async updateMeAvatar(formData, errorHandler = () => {}) {
        let url = this.baseUrl + '/me/avatar';

        return this.api.postRequest(url, formData, true)
            .then(response => this.processResponse(response, errorHandler))
            .catch(error => { if (typeof errorHandler === 'function') errorHandler(error); return false; });
    }


    async login(email, password, rememberMe = false, errorHandler = () => {}) {
        let url = this.baseUrl + '/login';

        return this.api.postRequest(url, {
            email: email,
            password: password,
            remember_me: rememberMe
        })
            .then(response => this.processResponse(response, errorHandler))
            .catch(error => typeof errorHandler === 'function' ? errorHandler(error) : null);
    }


    async refresh(refreshToken, errorHandler = () => {}) {
        let url = this.baseUrl + '/refresh';

        return this.api.postRequest(url, {
            refresh_token: refreshToken
        })
            .then(response => {
                if (this.responseIsSuccessful(response)) {
                    return response;
                } else {
                    errorHandler(response);
                }

                return false;
            })
            .catch(error => typeof errorHandler === 'function' ? errorHandler(error) : null);
    }


    async logout(errorHandler = () => {}) {
        let url = this.baseUrl + '/logout';

        return this.api.postRequest(url)
            .then(response => this.processResponse(response, errorHandler))
            .catch(error => typeof errorHandler === 'function' ? errorHandler(error) : null);
    }
}